export default __webpack_public_path__ + "static/media/avatar.efd66cdc.svg";